'use strict';

const React = require( 'react' );
const cookie = require( 'react-cookie' );
const classNames = require( 'classnames' );
const ParkingEngine = require( './parking-engine.jsx' );
const HorizontalParkingEngine = require( './parking-engine-horizontal.jsx' );
const HotelEngine = require( './hotels-engine.jsx' );
const HotelParkingEngine = require( './hotel-parking-engine.jsx' );
const Helpers = require( '../../../../../_plugins/lib/helpers.js' );
const propTypes = require('prop-types');
const PPCGetQuery = require( '../../../../../_plugins/lib/ppc.js' );
const { string, object, array, func, bool } = propTypes;
const createReactClass = require('create-react-class');

const MultiEngine = createReactClass({
  mixins: [Helpers],

  propTypes: {
    agentData: object.isRequired,
    selectedClass: string,
    hiddenLocation: string,
    cookieKey: string,
    domainSettings: object,
    formSettings: object,
    productList: array,
    locations: object,
    RoomTypes: object,
    sortOptions: object,
    pageData: object,
    setVar: object,
    agentSettings: object,
    engineSearchField: string,
    productCallBack: func,
    showFlight: bool,
    horizontal: bool,
    terminalLink: bool,
    showFlightDropdown: bool
  },

  getInitialState() {
    return {
      selectedProduct: this.getSelectedProduct( )
    };
  },

  getLocation() {
    const { selectedProduct } = this.state
    let location = this.getLocationFromParam( )
    if ( location || typeof window === 'undefined' ) return location
    const localStorageKey = 'desktopEngine'+selectedProduct.toUpperCase()+'SSG'
    const storedLocation = (window.localStorage[localStorageKey]) ? JSON.parse(window.localStorage[localStorageKey]) : false
    return ( storedLocation && storedLocation.Location ) ? storedLocation.Location : location
  },

  getLocationFromParam( ) {
    const queryString = PPCGetQuery.getQueryData( );
    return queryString.location || queryString.Location || '';
  },

  getDefaultProps() {
    return {
      selectedClass: ' hilit selected',
      cookieKey: 'chosenEngine',
      setVar: { },
      showFlight: false,
      horizontal: false,
      showFlightDropdown: false
    };
  },

  setEngineCookie( product ) {
    const { cookieKey } = this.props;
    cookie.remove( cookieKey, '/' );
    const expiry = new Date( );
    expiry.setTime( expiry.getTime( ) + ( 90 * 24 * 60 * 60 * 1000 ));
    cookie.save( cookieKey, product, { expires: expiry, path: '/' } );
  },

  getEngineCookie( ) {
    const { cookieKey, setVar } = this.props;
    const selectedProduct = cookie.load( cookieKey );
    if ( !selectedProduct ) return false;
    if ( !this.showEngineProduct( null, selectedProduct )) return false;
    if ( setVar[selectedProduct + '-engine-link'] ) return false;
    return selectedProduct;
  },

  getDefaultProduct( ) {
    const { productList = [ ] } = this.props;
    if ( productList.length && productList.indexOf( 'cp' ) < 0 ) return 'hcp';
    return 'cp';
  },

  getSelectedProduct() {
    const { agentData: { OptionFlags }, formSettings: { engineOptions = { } }, productList = [ ] } = this.props;
    let selectedProduct = this.getDefaultProduct( );
    if ( this.getEngineCookie( )) selectedProduct = this.getEngineCookie( );
    if ( !OptionFlags ) return selectedProduct;
    if ( OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelBookings !== 'N' && OptionFlags.HotelParking === 'N' ) {
      selectedProduct = 'ho';
    } else if ( OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelParking !== 'N' ) {
      selectedProduct = 'hcp';
    } else if ( OptionFlags.HotelBookings === 'N' && OptionFlags.CarParkBookings !== 'N' ) {
      selectedProduct = 'cp';
    }
    const queryString = PPCGetQuery.getQueryData( );
    if ( queryString.chosen ) {
      const chosen = queryString.chosen.toLowerCase( );
      if ( productList.length && productList.indexOf( chosen ) >= 0 ) {
        selectedProduct = chosen;
      } else if ( Object.keys( engineOptions ).indexOf( chosen ) >= 0 ) {
        selectedProduct = chosen;
      }
    }
    return selectedProduct;
  },

  navigate( link ) {
    window.location = link;
  },

  clickLink( e ) {
    const { productCallBack } = this.props;
    let el = e.target.parentElement;
    if ( el.tagName !== 'LABEL' ) el = this.$( 'label', e.target.parentElement );
    let link = el.getAttribute( 'data-link' );
    const mobileLink = el.getAttribute( 'data-mobile-link' );
    const selectedProduct = el.getAttribute( 'data-product' );
    const { flatEngine } = this.refs;
    // on mobile layout we hide the engine so lets link to the pages instead
    const isMobile = !this.isVisible( '.options', flatEngine );

    if ( !link ) {
      this.setEngineCookie( selectedProduct );
      this.setState({
        selectedProduct
      });
      if ( productCallBack ) productCallBack( selectedProduct );
    }
    if ( link || ( isMobile && mobileLink )) {
      this.navigate( link || mobileLink );
    }
    return false;
  },

  makeOption( { productClass, product, text, link, mobileLink }, key, groupName ) {
    const selectedProduct = this.getSelectedProduct( );
    let { selectedClass, setVar } = this.props;
    if ( setVar[product + '-engine-link'] ) link = setVar[product + '-engine-link'];
    const checked = selectedProduct === product;
    const classUsed = classNames(
      productClass,
      'radio',
      checked ? selectedClass : null
    );
    return (
      <li key={ key } className={ classUsed }>
        <input type="radio" checked={checked} className="sP hxtrack" name={ groupName } data-track-name="select_product" id={'hxEmbedsp_' + product} onChange={ this.clickLink } defaultValue={product} />
        <label data-product={product} data-link={link} onClick={ this.clickLink } data-mobile-link={mobileLink} htmlFor={'hxEmbedsp_' + product} dangerouslySetInnerHTML={{ __html: text }} />
      </li>
    );
  },

  cantSellProduct( item, OptionFlags, selectedProduct ) {
    return ( selectedProduct !== item.product && OptionFlags && item.canSellFlag && OptionFlags[item.canSellFlag] === 'N' );
  },

  showEngineProduct( option, productType ) {
    const { productList = [ ], agentData: { OptionFlags } } = this.props;
    if ( productList.length && productList.indexOf( productType ) < 0 ) return false;
    if ( !OptionFlags || !option ) return true;
    if ( OptionFlags[option] === 'N' ) return false;
    return true;
  },

  getEngineOptions( productList, groupName ) {
    const { agentData, formSettings: { engineOptions } } = this.props;
    const { OptionFlags } = agentData;
    const selectedProduct = this.getSelectedProduct( );
    if ( !productList.length ) {
      return Object.keys( engineOptions ).reduce( ( result, option ) => {
        const product = engineOptions[ option ];
        if ( this.cantSellProduct( product, OptionFlags, selectedProduct ) ) return result;
        result.push( this.makeOption( product, option, groupName ));
        return result;
      }, [ ]);
    }
    return productList.reduce( ( products, product ) => {
      const result = Object.keys( engineOptions ).filter( option => {
        const engineOption = engineOptions[option];
        if ( engineOption.product !== product ) return false;
        if ( this.cantSellProduct( engineOption, OptionFlags, selectedProduct ) ) return false;
        return true;
      });
      if ( !result.length ) return products;
      products.push( this.makeOption( engineOptions[result[0]], products.length, groupName ));
      return products;
    }, [ ]);
  },

  render() {
    const {
      domainSettings,
      formSettings,
      locations,
      RoomTypes,
      pageData,
      hiddenLocation,
      agentSettings,
      agentData,
      sortOptions,
      setVar,
      engineSearchField,
      productList = [ ],
      showFlight,
      horizontal,
      terminalLink,
      showFlightDropdown
    } = this.props;
    const selectedProduct = this.getSelectedProduct( );
    const engineOptions = this.getEngineOptions( productList, 'selectProduct' );

    return (
      <div id="flatEngine" className="clearfix" ref="flatEngine">
        { engineOptions.length !== 1 && (
          <div className="allProducts">
            <ul className="list-inline unstyled sp text-center">{ engineOptions }</ul>
          </div>
        )}
        <div className="options">
          { this.showEngineProduct( 'HotelBookings', 'ho' ) &&
            <HotelEngine showFlight={ showFlight } domainSettings={ domainSettings } formSettings={ formSettings } locations={ locations } RoomTypes={ RoomTypes } hiddenLocation={ hiddenLocation } Location={ this.getLocation( ) } sortOptions={ sortOptions && sortOptions.hotels } pageData={ pageData } agentSettings={ agentSettings } agentData={ agentData } showSort={ setVar.showSort === 'true' } selected={selectedProduct} engineSearchField={ engineSearchField } />
          }
          { this.showEngineProduct( 'HotelBookings', 'hcp' ) &&
            <HotelParkingEngine showFlight={ showFlight } domainSettings={ domainSettings } formSettings={ formSettings } locations={ locations } RoomTypes={ RoomTypes } hiddenLocation={ hiddenLocation } Location={ this.getLocation( ) } sortOptions={ sortOptions && sortOptions.hotels } pageData={ pageData } agentSettings={ agentSettings } agentData={ agentData } showSort={ setVar.showSort === 'true' } selected={selectedProduct} engineSearchField={ engineSearchField } />
          }
          { this.showEngineProduct( 'CarParkBookings', 'cp' ) && horizontal && (
            <HorizontalParkingEngine
              showFlight={ showFlight }
              domainSettings={ domainSettings }
              formSettings={ formSettings }
              locations={ locations }
              hiddenLocation={ hiddenLocation }
              Location={ this.getLocation( ) }
              pageData={ pageData }
              sortOptions={ sortOptions && sortOptions.carParking }
              agentSettings={ agentSettings }
              agentData={ agentData }
              selected={selectedProduct}
              showSort={ setVar.showSort === 'true' }
              showFilters={ setVar.showFilters === 'true' }
              engineSearchField={ engineSearchField }
              terminalLink={terminalLink}
              showFlightDropdown={showFlightDropdown}
            />
          ) || (
            this.showEngineProduct( 'CarParkBookings', 'cp' ) && <ParkingEngine
              showFlight={ showFlight }
              domainSettings={ domainSettings }
              formSettings={ formSettings }
              locations={ locations }
              hiddenLocation={ hiddenLocation }
              Location={ this.getLocation( ) }
              pageData={ pageData }
              sortOptions={ sortOptions && sortOptions.carParking }
              agentSettings={ agentSettings }
              agentData={ agentData }
              selected={selectedProduct}
              showSort={ setVar.showSort === 'true' }
              showFilters={ setVar.showFilters === 'true' }
              engineSearchField={ engineSearchField }
            />
          )}
        </div>
      </div>
    );
  }
});

module.exports = MultiEngine;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/engine-controller.jsx